import React from 'react';

import type CK from '~/types/contentking';

import CancelButton from '~/components/app/CancelButton';
import Form from '~/components/atoms/forms/basis/Form';
import ModalButtonsLayout from '~/components/patterns/modals/parts/ModalButtonsLayout';
import SimpleModal, {
	SimpleModalSize,
} from '~/components/patterns/modals/SimpleModal';
import SubmitButton from '~/components/app/SubmitButton';

import {
	useDeleteIncorrectLinksMutation,
} from './DeleteIncorrectLinksModal.gql';

import useClassicFormBehavior from '~/hooks/useClassicFormBehavior';



type Props = {
	websiteId: CK.WebsiteId,
};

const DeleteIncorrectLinksModal: React.FC<Props> = (props) => {
	const {
		websiteId,
	} = props;

	const classicFormBehavior = useClassicFormBehavior();

	const [deleteIncorrectLinks] = useDeleteIncorrectLinksMutation();

	const handleSubmit = React.useCallback(
		async () => {
			await deleteIncorrectLinks({
				variables: {
					websiteId,
				},
			});

			classicFormBehavior.finish();
		},
		[
			classicFormBehavior,
			deleteIncorrectLinks,
			websiteId,
		],
	);

	return (
		<SimpleModal
			size={SimpleModalSize.Small}
			title="Delete incorrect links"
		>
			<Form
				defaultDataHasChanged={true}
				onSuccess={handleSubmit}
			>
				<ModalButtonsLayout>
					<CancelButton />

					<SubmitButton>
						Delete incorrect links
					</SubmitButton>
				</ModalButtonsLayout>
			</Form>
		</SimpleModal>
	);
};



export default DeleteIncorrectLinksModal;
